import { NgModule } from '@angular/core';
import { SetupParameterComponent } from './containers/setup-parameter.component';
import { SharedModule } from '@bd/shared/shared.module';
import { EditSetupParameterComponent } from './containers/components/edit-setup-parameter.component';

@NgModule({
  declarations: [
    SetupParameterComponent,
    EditSetupParameterComponent
  ],
  imports: [
    SharedModule
  ]
})
export class SetupParameterModule { }
